import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditStepPayload } from '@app-store/slices/campaigns/editStep'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IEditStepPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.campaigns.editStep
const { onChangeStep } = rootActions.ui.emailCampaign

function* editStepSagaTask({ payload }) {
    try {
        const response = yield axios.put(
            `/notifications/campaigns/${payload.campaignId}/step/${payload.stepId}`,
            payload.data
        )
        if (response.success) {
            onChangeStep({
                index: payload.index,
                data: { hasChanged: false }
            })
            yield put(onSuccess(response.result))
            yield put(rootActions.ui.emailCampaign.replaceStepById(response.result))
            yield put(payload?.sagaCB?.onSuccess(response.result))
            notification.success({
                message: 'Step updated successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editStepSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editStepSagaTask)
}

export default editStepSaga
